// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_f5-b";
export var colorBlue = "_f5-8";
export var colorDot = "_f5-0";
export var colorDotLarge = "_f5-2";
export var colorDotSmall = "_f5-1";
export var colorGreen = "_f5-7";
export var colorGrey = "_f5-3";
export var colorOrange = "_f5-5";
export var colorPink = "_f5-a";
export var colorPurple = "_f5-9";
export var colorRed = "_f5-4";
export var colorYellow = "_f5-6";